import { LucideIcon } from "lucide-react";
import { Dispatch, SetStateAction } from "react";

function DisplayModeBtn({
	Icon,
	mode,
	label,
	setDisplayMode,
	displayMode,
}: {
	Icon: LucideIcon;
	mode: "list" | "category";
	label: string;
	setDisplayMode: Dispatch<SetStateAction<"list" | "category">>;
	displayMode: "list" | "category";
}) {
	const active = displayMode === mode;
	return (
		<label
			onClick={() => setDisplayMode(mode)}
			className={`flex items-center gap-2 cursor-pointer hover:scale-105 transition-transform ${
				active ? "text-primary" : "inherit"
			}`}
		>
			<Icon
				className={` p-1 ${
					active ? "bg-extended-rose-100  rounded" : ""
				}`}
			/>{" "}
			{label}
		</label>
	);
}
export default DisplayModeBtn;
